import React from 'react';
import { motion } from 'framer-motion';

function TopBarStatChip({ label, value, highlight = false, prefix = '' }) {
  return (
    <div
      className={`hidden items-center gap-1.5 rounded-xl border px-2 py-1.5 shadow-soft backdrop-blur-sm sm:inline-flex sm:rounded-2xl sm:px-2.5 sm:py-2 ${
        highlight
          ? 'border-orange-300/80 bg-gradient-to-r from-orange-50 to-amber-50 text-orange-700   '
          : 'border-white/30 bg-white/40  '
      }`}
    >
      <span
        className={`text-[10px] font-semibold uppercase tracking-wide ${
          highlight ? 'text-orange-600/90 ' : 'text-secondary-500 '
        }`}
      >
        {label}
      </span>
      <span
        className={`text-xs font-bold tabular-nums sm:text-sm ${
          highlight ? 'text-orange-700 ' : 'text-secondary-900 '
        }`}
      >
        {prefix}
        {value}
      </span>
    </div>
  );
}

/**
 * Compact metric chips for the TopBar.
 * @param {{ stats?: Array<{ id?: string, label: string, value: React.ReactNode, highlight?: boolean, prefix?: string }> }} props
 */
function TopBarStats({ stats = [] }) {
  if (!stats.length) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      className="mr-1 hidden items-center gap-1.5 sm:flex sm:gap-2"
      aria-label="Key metrics"
    >
      {stats.map((stat, index) => (
        <TopBarStatChip
          key={stat.id || `${stat.label}-${index}`}
          label={stat.label}
          value={stat.value}
          highlight={stat.highlight}
          prefix={stat.prefix}
        />
      ))}
    </motion.div>
  );
}

export default TopBarStats;
